import { Injectable } from '@angular/core';
import { randomUuid } from './uuid.util';

@Injectable({ providedIn: 'root' })
export class CorrelationContextService {
  private activeCorrelationId: string | null = null;

  startFlow(): string {
    this.activeCorrelationId = randomUuid();
    return this.activeCorrelationId;
  }

  endFlow(): void {
    this.activeCorrelationId = null;
  }

  getCorrelationId(): string | null {
    return this.activeCorrelationId;
  }

  /** ID de correlación activo o uno nuevo si no hay flujo. */
  resolveCorrelationId(): string {
    return this.activeCorrelationId ?? randomUuid();
  }

  /**
   * Inicia un flujo, ejecuta fn y garantiza endFlow() al terminar (éxito o error).
   */
  withFlow<T>(fn: (correlationId: string) => T): T {
    const correlationId = this.startFlow();
    try {
      return fn(correlationId);
    } finally {
      this.endFlow();
    }
  }

  /**
   * Ejecuta fn reutilizando un correlationId existente (p. ej. Store & Forward).
   */
  runInFlow<T>(correlationId: string, fn: () => T): T {
    const previous = this.activeCorrelationId;
    this.activeCorrelationId = correlationId;
    try {
      return fn();
    } finally {
      this.activeCorrelationId = previous;
    }
  }
}
